export default {"src":"/kareline/_next/static/media/karePediaFirstLogo.1c00a188.gif","height":93,"width":145,"blurWidth":0,"blurHeight":0};